import { Controller } from 'stimulus';

export default class extends Controller {
  forward(event) {
    const url = new URL(event.currentTarget.href);
    url.search = window.location.search;

    event.currentTarget.setAttribute('data-ui--twin-turbo-modal-trigger-url-value', url);
  }
}
